import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EditorComponent from 'components/editor/editor';
import { getItinerary, setItinerary } from '../../actions/itinerary';

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getItinerary,
        setItinerary
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        currentUser: state.currentUser,
        itinerary: state.itinerary
    };
}

const Editor = connect(
    mapStateToProps,
    mapDispatchToProps
)(EditorComponent);

export default Editor;


// WEBPACK FOOTER //
// ./src/app/containers/editor/editor.jsx